import { useCallback, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { get } from 'app/utils/lo/lo';
import { toggleMessageReaction } from 'store/actions/chat/chatActions';

const ensureShortcode = input => {
    if (!input) return null;
    const s = String(input).trim();
    if (!s) return null;
    return s.startsWith(':') && s.endsWith(':') ? s : `:${s.replace(/^:|:$/g, '')}:`;
};

export const useMessageReactions = (message, rid) => {
    const dispatch = useDispatch();
    const currentUsername = useSelector(state => get(state, 'user.profile.primary.username'));
    const reactions = useMemo(() => message?.reactions || [], [message]);
    const onToggle = useCallback(
        emoji => {
            if (!rid || !message || !message.id || !emoji) return;
            const key = ensureShortcode(emoji);
            if (!key) return;
            const reaction = reactions.find(r => r.emoji === key);
            const alreadyReacted = reaction ? reaction.usernames.includes(currentUsername) : false;
            dispatch(toggleMessageReaction(rid, message.id, key, !alreadyReacted));
        },
        [reactions, rid, message, currentUsername, dispatch]
    );
    return { reactions, currentUsername, onToggle };
};
